import * as React from 'react';
import { Button } from '@cotera/client/v0/components/ui/button';

export type ResourcePickerFooterProps = {
  selectionCount: number;
  onConfirm: () => void;
  /** Label for the action button. Defaults to "Insert". */
  actionLabel?: string;
  /** Contextual label shown on the left, e.g. "Attaching to Code Issue Fixer". */
  contextLabel?: string;
};

export const ResourcePickerFooter: React.FC<ResourcePickerFooterProps> = ({
  selectionCount,
  onConfirm,
  actionLabel = 'Insert',
  contextLabel,
}) => {
  return (
    <div className="flex items-center justify-between border-t border-border px-3 py-2">
      <span className="text-xs text-muted-foreground">
        {contextLabel !== undefined ? contextLabel : ''}
      </span>
      <div className="flex items-center gap-3">
        <span className="text-xs text-muted-foreground tabular-nums">
          {selectionCount} selected
        </span>
        <Button disabled={selectionCount === 0} onClick={onConfirm}>
          {actionLabel}
        </Button>
      </div>
    </div>
  );
};
